import { render, staticRenderFns } from "./SystemTagTreeItem.vue?vue&type=template&id=55cb924a&scoped=true"
import script from "./SystemTagTreeItem.vue?vue&type=script&lang=js"
export * from "./SystemTagTreeItem.vue?vue&type=script&lang=js"
import style0 from "./SystemTagTreeItem.vue?vue&type=style&index=0&id=55cb924a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cb924a",
  null
  
)

export default component.exports